import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AuthenticatedPage } from '../components/AuthenticatedPage';
import Container from '../components/container/Container';
import { FeedbackSurvey } from '../components/SWOT/FeedbackSurvey';
import { Greetings } from '../components/SWOT/Greetings';
import { Resources } from '../components/SWOT/Resources';
import { SWOTAnalysis } from '../components/SWOT/SWOTAnalysis';
import { SWOTHeader } from '../components/SWOT/SWOTHeader';
import { SWOTReport } from '../components/SWOT/SWOTReport';
import { usePreEmploymentAssessmentContext } from '../hooks/use-pre-employment-assessment.hooks';
import {
  dispatchUpsertPreEmploymentAssessment,
  PreEmploymentAssessmentStatus,
} from '../redux/slice/pre-employment-assessment';
import { PreEmploymentAssessmentState } from '../redux/slice/pre-employment-assessment/pre-employment-assessment.slice';
import { useAppDispatch } from '../redux/store';
import logger from '../services/logger';

export const SWOT: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { componentName } = useParams();
  const [step, setStep] = useState(1);

  useEffect(() => {
    void dispatch(dispatchUpsertPreEmploymentAssessment());
  }, []);
  const preEmploymentAssessment: PreEmploymentAssessmentState = usePreEmploymentAssessmentContext();

  useEffect(() => {
    if (Object.keys(preEmploymentAssessment).length) {
      if (!preEmploymentAssessment || !Object.keys(preEmploymentAssessment).length) {
        return;
      } else if (preEmploymentAssessment.status !== PreEmploymentAssessmentStatus.COMPLETE) {
        logger.debug('Invalid pre-employment assessment status.', {
          preEmploymentAssessment,
        });
        navigate('/pre-employment/start');
      }
    }
  }, [navigate, preEmploymentAssessment]);

  useEffect(() => {
    if (!componentName) {
      navigate('/swot/step1');
    } else {
      setStep(parseInt(componentName?.replace('step', '') || '1'));
    }
    window.scrollTo(0, 0);
  }, [componentName]);

  const renderFormStep = () => {
    switch (componentName) {
      case 'step1':
        return <Greetings />;
      case 'step2':
        return <SWOTAnalysis />;
      case 'step3':
        return <SWOTReport />;
      case 'step4':
        return <FeedbackSurvey />;
      case 'step5':
        return <Resources />;
      default:
        return null;
    }
  };

  return (
    <>
      <section className={`steps relative swot-step`}>
        <Container>
          <SWOTHeader step={step}>
            <>{renderFormStep()}</>
          </SWOTHeader>
        </Container>
      </section>
    </>
  );
};

export const SWOTPage: React.FC = () => {
  return <AuthenticatedPage render={() => <SWOT />} />;
};
